import http from '../request';

export const newslist = (params: INewParams): RES<INewsModel> => http.post("/system/news/list1?pageSize=4", params)

export const newslistPage = (params: INewParams): RES<INewsModel> => http.post("/system/news/list1", params)

export const newsget = (): RES<INewInfoModel> => http.get("/system/news/get")
